import Input from '@vromo/ui/components/Input';
import React, { memo } from 'react';
import { RateInput } from '../Components';
import styles from '../driverReport.style';

interface RateInputSectionProps {
    label: string;
    id: string;
    testId: string;
    value: number;
    disabled: boolean;
    onChange?: JSX.IntrinsicElements['input']['onChange'];
}

const RateInputSection = memo(
    ({ label, id, testId, value, onChange, disabled }: RateInputSectionProps) => (
        <RateInput>
            <label>{label}</label>
            <Input
                {...{ id, value, onChange }}
                data-testid={testId}
                style={styles.numberInput}
                disabled={disabled}
                type="number"
                step="0.01"
            />
        </RateInput>
    )
);

export default RateInputSection;
